export default "__VITE_ASSET__9r9L7vQG__"